import styled from 'styled-components';

export const Container = styled.div`
  min-width: 420px;
  padding: 4px 8px 8px;
  color: ${({ theme }) => theme.colors.text};
`;

export const Section = styled.section`
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h6`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0 0 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const InfoLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const InfoValue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background-color: ${({ color }) => color || '#888'};
  width: fit-content;
`;

export const AddressCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};

  img {
    width: 28px;
    height: 28px;
    opacity: 0.6;
    flex-shrink: 0;
  }

  span {
    font-size: 12px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const SelectRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;

  label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const ProductsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

/* ---- Footer Totals ---- */

export const TotalsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 16px;
  margin-top: 8px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.lightGrayOpacity};
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: ${({ $highlight }) => $highlight ? undefined : undefined};

  span:first-child {
    color: ${({ theme, $muted }) => $muted
    ? theme.colors.textSecondary
    : theme.colors.text};
    font-weight: ${({ $bold }) => $bold ? '700' : '400'};
    font-size: ${({ $bold }) => $bold ? '14px' : '13px'};
  }

  span:last-child {
    font-weight: ${({ $bold }) => $bold ? '700' : '500'};
    font-size: ${({ $bold }) => $bold ? '15px' : '13px'};
    color: ${({ theme, $green }) => $green
    ? theme.colors.success
    : theme.colors.text};
  }
`;

export const TotalDivider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.lightGrayOpacity};
  margin: 4px 0;
`;

export const ContainerPayment = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ConfirmPayment = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
  background: ${({ confirm }) => confirm ? '#5D9B76' : '#D4764E'};
`;
